// extracted by mini-css-extract-plugin
export default {"icon":"HelpTipIcon-module__icon___l+OPV text-primary"};